<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M921.3 123.1H102.7c-17 0-30.7 13.7-30.7 30.7v614c0 17 13.7 30.7 30.7 30.7h153.5v71.6c0 10.6 5.5 20.5 14.6 26.1 4.9 3 10.5 4.6 16.1 4.6 4.7 0 9.4-1.1 13.7-3.2l198.2-99.1h422.5c17 0 30.7-13.7 30.7-30.7v-614c0-17-13.7-30.7-30.7-30.7zm-30.7 614H491.5c-4.7 0-9.4 1.1-13.7 3.2l-160.2 80.1v-52.6c0-17-13.7-30.7-30.7-30.7H133.4V184.6h757.2v552.5z" fill="#d73e18" />
      <path d="M133.4 184.6v552.5h153.5c17 0 30.7 13.7 30.7 30.7v52.6l160.2-80.1c4.3-2.1 9-3.2 13.7-3.2h399.1V184.6H133.4zm204.6 307c0 16.9-13.7 30.7-30.7 30.7s-30.7-13.7-30.7-30.7v-61.4c0-17 13.7-30.7 30.7-30.7s30.7 13.7 30.7 30.7v61.4zm204.7 0c0 16.9-13.7 30.7-30.7 30.7s-30.7-13.7-30.7-30.7v-61.4c0-17 13.7-30.7 30.7-30.7s30.7 13.7 30.7 30.7v61.4zm204.7 0c0 16.9-13.8 30.7-30.7 30.7-17 0-30.7-13.7-30.7-30.7v-61.4c0-17 13.7-30.7 30.7-30.7s30.7 13.7 30.7 30.7v61.4z" fill="#fbd7a2" />
      <path d="M338 430.2v61.4c0 16.9-13.7 30.7-30.7 30.7s-30.7-13.7-30.7-30.7v-61.4c0-17 13.7-30.7 30.7-30.7s30.7 13.7 30.7 30.7zm204.7 0v61.4c0 16.9-13.7 30.7-30.7 30.7s-30.7-13.7-30.7-30.7v-61.4c0-17 13.7-30.7 30.7-30.7s30.7 13.7 30.7 30.7zm204.7 0v61.4c0 16.9-13.8 30.7-30.7 30.7-17 0-30.7-13.7-30.7-30.7v-61.4c0-17 13.7-30.7 30.7-30.7s30.7 13.7 30.7 30.7z" fill="#d73e18" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1.2em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
